import { PageHeader } from "@/components/common/PageHeader";
import { DataTable, Column } from "@/components/tables/DataTable";
import { useGetFeedbacksQuery, type Feedback } from "@/redux/slices/feedbackApi";
import { format } from "date-fns";
import { Star } from "lucide-react";
import { Button } from "@/components/ui/button";
import { RotateCw } from "lucide-react";
import { cn } from "@/lib/utils";

export default function StudentFeedback() {
  const { data: feedbacks, isFetching, refetch } = useGetFeedbacksQuery();
  const safeFeedbacks = Array.isArray(feedbacks) ? feedbacks : [];

  const columns: Column<Feedback>[] = [
    { 
      key: "studentName", 
      header: "Student", 
      render: (r) => (
        <div>
          <div className="font-medium text-foreground">{r.studentName}</div>
          <div className="text-sm text-muted-foreground">{r.studentEmail}</div>
        </div>
      ) 
    },
    { 
      key: "rating", 
      header: "Rating", 
      render: (r) => (
        <div className="flex items-center gap-1">
          {Array.from({ length: 5 }).map((_, i) => (
            <Star 
              key={i} 
              className={cn("w-4 h-4", i < r.rating ? "fill-yellow-400 text-yellow-400" : "text-muted")} 
            />
          ))}
        </div>
      ) 
    },
    { key: "feedbackText", header: "Feedback", render: (r) => <div className="max-w-md truncate" title={r.feedbackText}>{r.feedbackText}</div> },
    { key: "createdAt", header: "Date", render: (r) => format(new Date(r.createdAt), "dd MMM yyyy, hh:mm a") },
  ];

  return (
    <div className="min-h-screen bg-muted/20">
      <PageHeader
        title="Student Feedback"
        description="View ratings and comments submitted by students from the app"
        action={
          <Button variant="outline" size="icon" onClick={() => refetch()} disabled={isFetching}>
             <RotateCw className={cn("h-4 w-4", isFetching && "animate-spin")} />
          </Button>
        }
      />
      <div className="space-y-6 p-4 sm:p-6 lg:p-8">
        <DataTable
          columns={columns}
          rows={safeFeedbacks}
          loading={isFetching}
          total={safeFeedbacks.length}
          page={1}
          limit={100}
          onPageChange={() => {}}
          onLimitChange={() => {}}
        />
      </div>
    </div>
  );
}
